import {Component, OnInit} from '@angular/core';
import {Merchant, MerchantMedia} from "../../../../common/interfaces/Merchant";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {MerchantService} from "../../../../common/services/merchant.service";

@Component({
  selector: 'merchant-images-and-videos-tab',
  templateUrl: './merchant-images-and-videos-tab.component.html',
  styleUrls: ['./merchant-images-and-videos-tab.component.scss']
})
export class MerchantImagesAndVideosTabComponent implements OnInit {

  merchant: Merchant | null = null
  images: MerchantMedia[] = []
  videos: MerchantMedia[] = []

  constructor(
    private sanitizer: DomSanitizer,
    private merchantService: MerchantService
  ) {
  }

  ngOnInit(): void {
    this.merchantService.getMerchantInfo().subscribe({
      next: (merchant) => {
        this.merchant = merchant
        this.images = merchant?.images.filter((media) => media.type === "IMAGE") ?? []
        this.videos = merchant?.images.filter((media) => media.type === "VIDEO") ?? []
      }
    })
  }

  getSanitizedVideoUrl(url: string): SafeResourceUrl {
    // let embedUrl = url.replace("watch", "embed")
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}
